<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资源中心</el-breadcrumb-item>
        <el-breadcrumb-item>充电站管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane label="充电站管理" name="stationList">
              <!--      查询组件       -->
              <el-row>
                <search
                  @submitStationSearchForm="submitStationSearchForm"
                  :stationSearchForm="stationSearchForm"
                  :operatorForSelect="operatorForSelect"
                  :stationStatusData="enumData.stationStatusData"
                  :stationTypeData="enumData.stationTypeData"
                  :getStationsLoading="getStationsLoading"
                  ref="searchForm"
                >
                </search>
                <!--       新增组件         -->
                <el-form>
<!--                  <el-col :span="2.5" class="diy-class" style="margin-right: 10px;">
                    <el-form-item>
                      <el-button size="mini" type="primary" @click="newStationAdd" icon="el-icon-plus" class="el-btn"
                      v-if="checkPermission(['bee:res:station:quickSaveStation'])">
                        快速建站
                      </el-button>
                    </el-form-item>
                  </el-col>-->
                  <el-col :span="2" class="diy-class">
                    <el-form-item>
                      <el-button size="mini" type="primary" @click="stationAdd" icon="el-icon-plus" class="el-btn"
                                 v-if="checkPermission(['bee:res:station:saveOrUpdateStation'])">
                        新增电站
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-row>
              <!--       列表组件       -->
              <list
                @showViewVisible="showViewVisible"
                @stationEdit="stationEdit"
                @stationDelete="stationDelete"
                :tableData="tableData"
                :stationsLoading="stationsLoading"
              ></list>
              <!-- 分页组件 -->
              <Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
            </el-tab-pane>

<!--            <el-tab-pane label="充电站安全管理" name="safetyList" v-if="checkPermission(['bee:res:stationSafety:page'])">
              &lt;!&ndash;      查询组件       &ndash;&gt;
              <el-row>
                <safetySearch
                  @submitSafetySearchForm="submitSafetySearchForm"
                  :stationSearchForm="stationSearchForm"
                  :stationsForSelect="stationsForSelect"
                  :operatorForSelect="operatorForSelect"
                  :getStationsLoading="getStationsLoading"
                  @operatorSelect="operatorSelect"
                  ref="searchForm"
                >
                </safetySearch>
                &lt;!&ndash;       新增组件         &ndash;&gt;
                <el-form>
                  <el-col :span="2" class="diy-class">
                    <el-form-item>
                      <el-button size="mini" type="primary" @click="safetyAdd" icon="el-icon-plus" class="el-btn"
                                 v-if="checkPermission(['bee:res:station:saveOrUpdateStation'])">
                        新增管理
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-row>
              &lt;!&ndash;       列表组件       &ndash;&gt;
              <safetyList
                @safetyEdit="safetyEdit"
                @stationEdit="stationEdit"
                @stationDelete="stationDelete"
                @submitSafetySearchForm="submitSafetySearchForm"
                :tableSafetyData="tableSafetyData"
                :stationsLoading="stationsLoading"
              ></safetyList>
              &lt;!&ndash; 分页组件 &ndash;&gt;
              <Pagination v-bind:child-msg="pageparam" @callFather="changePage"></Pagination>
            </el-tab-pane>-->

            <!--<el-tab-pane label="登记充电站" name="second">登记充电站</el-tab-pane>-->
          </el-tabs>
        </el-col>
      </el-row>
      <!--新增组件-->
      <add
        @editSubmit="editSubmit"
        @closeAddForm="closeAddForm"
        :editForm="editForm"
        :addFormVisible="addFormVisible"
        :editSubmitLoading="editSubmitLoading"
        :operatorForSelect="operatorForSelect"
        :stationTypeData="enumData.stationTypeData"
        :stationStatusData="enumData.stationStatusData"
        :addressTypeData="enumData.addressTypeData"
        :businessTypeData="enumData.businessTypeData"
        :YesNoEnumData="enumData.YesNoEnumData"
        :feesTakeUpPileData="enumData.feesTakeUpPileData"
        :fastOrSlowData="enumData.fastOrSlowData"
        :isCecData="enumData.isCecData"
        :isProfitData="enumData.isProfitData"
        :isCouponsData="enumData.isCouponsData"
        :serviceBillingRulesSelect="serviceBillingRulesSelect"
      ></add>

      <!--编辑组件-->
       <update
        @editSubmit="editSubmit"
        @closeEditForm="closeEditForm"
        :editForm="editForm"
        :editFormVisible="editFormVisible"
        :editSubmitLoading="editSubmitLoading"
        :operatorForSelect="operatorForSelect"
        :stationTypeData="enumData.stationTypeData"
        :stationStatusData="enumData.stationStatusData"
        :addressTypeData="enumData.addressTypeData"
        :businessTypeData="enumData.businessTypeData"
        :YesNoEnumData="enumData.YesNoEnumData"
        :feesTakeUpPileData="enumData.feesTakeUpPileData"
        :fastOrSlowData="enumData.fastOrSlowData"
        :isCecData="enumData.isCecData"
        :isProfitData="enumData.isProfitData"
        :isCouponsData="enumData.isCouponsData"
      ></update>
      <!--   视图组件   -->
      <customizeView
        @closeView="closeView"
        @unbinding="unbinding"
        @dobinding="dobinding"
        @submitStationSearchForm="submitStationSearchForm"
        @revertUploadAvatarFormFileList="revertUploadAvatarFormFileList"
        @revertUploadSitePicFormFileList="revertUploadSitePicFormFileList"
        @revertStationPicturesFormFileList="revertStationPicturesFormFileList"
        :protocolEnumData="enumData.protocolEnumData"
        :pileModelEnumData="enumData.pileModelEnumData"
        :view-visible="viewVisible"
        :detailForm="detailForm"
        :searchTabsAddForm="searchTabsAddForm"
        :bindingRateForm="bindingRateForm"
        :serviceBillingRulesSelect = "serviceBillingRulesSelect"
        :uploadAvatarForm="uploadAvatarForm"
        :uploadSitePicForm="uploadSitePicForm"
        :newUploadSitePicturesForm="newUploadSitePicturesForm"
        :uploadAvatarFormFileList="uploadAvatarFormFileList"
        :uploadSitePicFormFileList="uploadSitePicFormFileList"
        :newUploadSitePicturesList="newUploadSitePicturesList"
        :stationImageUrlList="stationImageUrlList"
        :createPileAndGunForm="createPileAndGunForm"
      >
      </customizeView>
      <!--快速建站-->
      <quick-add
        @newEditSubmit="newEditSubmit"
        @closeNewEditForm="closeNewEditForm"
        :newEditForm="newEditForm"
        :newEditFormVisible="newEditFormVisible"
        :newEditSubmitLoading="newEditSubmitLoading"
        :operatorForSelect="operatorForSelect"
        :stationTypeData="enumData.stationTypeData"
        :stationStatusData="enumData.stationStatusData"
        :addressTypeData="enumData.addressTypeData"
        :businessTypeData="enumData.businessTypeData"
        :YesNoEnumData="enumData.YesNoEnumData"
        :feesTakeUpPileData="enumData.feesTakeUpPileData"
        :fastOrSlowData="enumData.fastOrSlowData"
        :isCecData="enumData.isCecData"
      ></quick-add>

      <!--新增组件-->
      <addSafety
        @safetyEditSubmit="safetyEditSubmit"
        @closeSafetyEditForm="closeSafetyEditForm"
        @submitSafetySearchForm="submitSafetySearchForm"
        @operatorSelect="operatorSelect"
        :safetyEditForm="safetyEditForm"
        :safetyEditFormVisible="safetyEditFormVisible"
        :safetyEditSubmitLoading="safetyEditSubmitLoading"
        :operatorForSelect="operatorForSelect"
        :stationSearchForm="stationSearchForm"
        :stationsForSelect="stationsForSelect"
        :auditStatusEnum="enumData.auditStatusEnum"
        :stationImageUrlList="stationImageUrlList"
        :newUploadSitePicturesList="newUploadSitePicturesList"
      ></addSafety>

      <el-dialog width="40%" :visible.sync="dialogInnerVisible">
        <!--快速搜索 form-->
        <el-form :model="innerForm" ref="innerForm" :inline="true" size="mini">
          <el-tabs v-model="innerFormName">
            <!--经纬坐标-->
            <el-tab-pane label="经纬坐标" name="coordinate">
              <el-row class="el_row_input row_input">
                <el-col :span="10" class="el_col_input">
                  <el-form-item label="经度：">
                    <el-input autocomplete="off" v-model="centerTemp.lng"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2" class="el_col_input">
                  <el-form-item label="纬度：">
                    <el-input autocomplete="off" v-model="centerTemp.lat"></el-input>
                  </el-form-item>
                </el-col>
                <!--                <el-col :span="2">-->
                <!--                  <el-form-item>-->
                <!--                    <el-button size="mini" class="el_search">搜索</el-button>-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
              </el-row>
              <!--百度地图组件-->
              <div class="BaiduMap">
                <baidu-map class="map" :center="centerTemp" :zoom="15" :scroll-wheel-zoom="true"
                           :map-style="{styleJson:styleJson}"
                           map-type="BMAP_NORMAL_MAP" @click="getClickInfo">
                  <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true"
                                  :autoLocation="true"></bm-geolocation>
                  <!--&lt;!&ndash;//添加一个小红点的，并将当前的经纬度写入数据中&ndash;&gt;-->
                  <bm-marker :position="centerTemp"></bm-marker>
                  <bm-control :offset="{width: '10px', height: '10px'}">
                    <bm-auto-complete v-model="keyword" :sugStyle="{zIndex: 9999}">
                      <el-input size="mini" v-model="keyword" placeholder="请输入地名关键字"></el-input> <!-- 这里指代一个自定义搜索框组件 -->
                    </bm-auto-complete>
                  </bm-control>
                  <bm-local-search :keyword="keyword" :auto-viewport="true"></bm-local-search>
                </baidu-map>
              </div>
              <!--内部对话框底部当前位置-->
              <el-row class="el_row_input rows_input">
                <el-col :span="24" class="el_col_input">
                  <el-form-item>
                    <label style="color: sienna;font-weight: bold" v-text="addressTemp"></label>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" plain @click="dialogInnerVisible = false">取 消</el-button>
          <el-button size="mini" plain type="primary" @click="confirmAddress">提交</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
  import Pagination from '../../../components/Pagination'
  import search from "./siteManager/search"
  import safetySearch from "./safetyManager/search"
  import list from "./siteManager/list"
  import safetyList from "./safetyManager/list"
  import add from "./siteManager/add"
  import addSafety from "./safetyManager/add"
  import quickAdd from "./siteManager/quickAdd"
  import customizeView from "./siteManager/customizeView"
  import stationApi from '../../resourceCenter/api/stationApi'
  import safetyApi from '../../resourceCenter/api/safetyApi'
  import commonApi from '../../resourceCenter/api/commonApi'
  import sysConfig from '@/../config/sysConfig'
  import update from "./siteManager/update";

  export default {
    name: 'siteManager',
    data() {
      return {
        stationsForSelect: '',
        enumData: [{
          canUseData: '',
          stationStatusData: '',
          stationTypeData: '',
          feesTakeUpPileData: '',
          fastOrSlowData: '',
          isCecData: '',
          isProfitData: '',
          YesNoEnumData: '',
          addressTypeData:'',
          businessTypeData:'',
          protocolEnumData:'',
          pileModelEnumData:'',
	  auditStatusEnum:''
        }],
        formType: "",
        operatorForSelect: [],
	auditStatusEnum: [],
        // restaurants: [],
        tableData: [{}],
	tableSafetyData: [{}],
        stationsLoading: false,
        stationSearchForm: {},
        getStationsLoading: false,
        editForm: {},
        newEditForm:{},
	safetyEditForm: {},
        editSubmitLoading: false,
        detailForm: {},
        innerForm: {},
        searchTabsAddForm: {
          listTag: [],
        },
        addFormVisible: false, // 外部对话框
        editFormVisible: false, // 外部对话框
        dialogInnerVisible: false, // 内部对话框
        viewVisible: false, // 视图
        multipleSelection: [],
        activeName: 'stationList',
        innerFormName: 'coordinate',
        detailFormName: 'stationBasicInformation',
        viewName: 'detailForm',
        showFilters: true,
        input: '',
        // 百度地图初始化数据
        baidumapSwitch: false,
        zoom: 16,
        location: '上海市',
        keyword: '',
        centerTemp: {
          lng: 121.384555, lat: 31.069087
        },
        // 设置center属性值
        provinceTemp: '',
        cityTemp: '',
        districtTemp: '',
        addressTemp: '',
        val_time: '', // 创建时间
        formLabelWidth: '155px',
        styleJson: [ // 百度地图自定义
          {
            featureType: "water",
            elementType: "all",
            stylers: {
              color: "#ffffff"
            }
          }
        ],
        bindingRateForm: {},
        serviceBillingRulesSelect: [],
        uploadAvatarForm: {},
        uploadSitePicForm: {},
        stationUploadImageForm:{},
        newUploadSitePicturesForm: {},
        uploadAvatarFormFileList: [],
        uploadSitePicFormFileList: [],
        newUploadSitePicturesList:[],
        stationImageUrlList:[],
        aLabelList: [],
        createPileAndGunForm:{},
        newEditFormVisible: false,
        safetyEditFormVisible: false,
        newEditSubmitLoading: false,
        safetyEditSubmitLoading: false,
        // 分页参数
        pageparam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      }
    },
    methods: {
      // 获取标签
      getStationLabelFn() {
        stationApi.getStationLabel().then((res) => {
          this.aLabelList = res.data;
        });
      },

      closeView(){
        this.viewVisible=false
        this.uploadAvatarFormFileList=[],
        this.uploadSitePicFormFileList=[],
        this.newUploadSitePicturesList=[],
        this.stationImageUrlList=[]
      },
      newStationAdd(){
        this.$nextTick(() => {
          this.newEditFormVisible = true;
          this.newEditForm = Object.assign({})
        })
      },
      safetyAdd() {
        this.$nextTick(() => {
          this.safetyEditFormVisible = true;
        })
      },

      safetyEdit(index, row) {
        this.$nextTick(() => {
          this.safetyEditForm = Object.assign({},row)
          let domain = sysConfig.apiPre;
          if (domain === "http://localhost") {
            domain = 'http://qectest.qingec.com/';
          }
          let picJson = this.safetyEditForm.pictures
          for (let index in picJson) {
            this.uploadSitePicFormFileList.push({name: "", url: domain + '/' + picJson[index]});
            this.newUploadSitePicturesList.push(
              {
                name: picJson[index],
                url: domain + '/' + picJson[index]
              }
            );
          }
          this.safetyEditFormVisible = true;
        })
      },

      //一键创建桩和枪
      createPileAndGun(index, row){
        this.createPileAndGunForm = {
          id: row.id,
          stationName: row.stationName,
          oneGunNum: row.oneGunNum,
          secondGunNum: row.secondGunNum,
          threeGunNum: row.threeGunNum,
          fourGunNum: row.fourGunNum
        }
      },
      safetyEditSubmit(safetyEditSubmit) {
        console.log("进入提交数据方法: " + JSON.stringify(this.safetyEditSubmit))
        safetyEditSubmit.validate((valid) => {
          if (!valid) {
            return;
          } else {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.safetyEditSubmitLoading = true;
              let param = JSON.stringify(this.safetyEditSubmit);
              stationApi.quickSaveStation(param).then((res) => {
                if (res.code === 0) {
                  this.$message({
                    message: res.message,
                    type: 'success'
                  });
                  this.newEditFormVisible = false;
                  this.submitSafetySearchForm()
                } else {
                  this.$message.error(res.message)
                }
                this.safetyEditSubmitLoading = false;
              })
            })
          }
        })
      },

      newEditSubmit(newEditSubmit) {
        newEditSubmit.validate((valid) => {
          if (!valid) {
            return;
          } else {
            /*if(this.editForm.address == null || this.editForm.address === 'undefined'){
              this.$message({
                message: "请选择充电站地址",
                type: 'error'
              });
              return;
            }*/
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.newEditSubmitLoading = true;
              let param = JSON.stringify(this.newEditForm);

              stationApi.quickSaveStation(param).then((res) => {
                if (res.code === 0) {
                  this.$message({
                    message: res.message,
                    type: 'success'
                  });
                  this.newEditFormVisible = false;
                  this.submitStationSearchForm()
                } else {
                  this.$message.error(res.message)
                }
                this.newEditSubmitLoading = false;
              })
            })
          }
        })
      },
      submitStationSearchForm() {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.getStationsLoading = true
          this.stationsLoading = true
          // let param = Object.assign({}, this.stationSearchForm)
          // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');
          this.stationSearchForm.operatorId=sessionStorage.getItem('operatorId');
          this.pageparam.t = this.stationSearchForm;
          let param = Object.assign({}, this.pageparam)
          stationApi.getStations(param).then((res) => {
            if (res.code === 0) {
              this.pageparam.total = res.data.total;
              this.tableData = res.data.records;
              // this.$message({
              //   message: res.message,
              //   type: 'success'
              // })
            } else {
              // this.$message.error(res.message)
            }
            this.getStationsLoading = false
            this.stationsLoading = false
          })
        })
      },
      submitSafetySearchForm() {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.getStationsLoading = true
          this.stationsLoading = true
          this.pageparam.t = this.stationSearchForm;
          let param = Object.assign({}, this.pageparam)
          safetyApi.getPage(param).then((res) => {
            if (res.code === 0) {
              this.pageparam.total = res.data.total;
              this.tableSafetyData = res.data.list;
            } else {
            }
            this.getStationsLoading = false
            this.stationsLoading = false
          })
        })
      },

      dialogInnerClick(tab, event) {
      },
      showNoRateAlert() {
        const message = [
          '<div style="line-height: 1.75; color: #606266; font-size: 14px; text-align: left;">',
          '<p style="margin: 0 0 12px; font-size: 15px; font-weight: 600; color: #303133;">暂无法新增充电站</p>',
          '<p style="margin: 0 0 12px; color: #909399;">请按以下步骤完成配置后再试：</p>',
          '<div style="padding: 14px 16px; background: #f5f7fa; border-radius: 4px; border-left: 3px solid #409eff;">',
          '<p style="margin: 8px 0;"><span style="display:inline-block;min-width:22px;height:22px;line-height:22px;text-align:center;background:#409eff;color:#fff;border-radius:50%;font-size:12px;margin-right:10px;vertical-align:middle;">1</span>',
          '<span style="vertical-align:middle;">进入 <strong style="color:#303133;">运营中心</strong></span></p>',
          '<p style="margin: 8px 0;"><span style="display:inline-block;min-width:22px;height:22px;line-height:22px;text-align:center;background:#409eff;color:#fff;border-radius:50%;font-size:12px;margin-right:10px;vertical-align:middle;">2</span>',
          '<span style="vertical-align:middle;">打开 <strong style="color:#303133;">费率管理</strong>，添加费率</span></p>',
          '<p style="margin: 8px 0 0;"><span style="display:inline-block;min-width:22px;height:22px;line-height:22px;text-align:center;background:#409eff;color:#fff;border-radius:50%;font-size:12px;margin-right:10px;vertical-align:middle;">3</span>',
          '<span style="vertical-align:middle;">返回本页，点击 <strong style="color:#303133;">新增电站</strong></span></p>',
          '</div>',
          '</div>'
        ].join('')
        this.$alert(message, '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false,
          customClass: 'station-no-rate-alert'
        })
      },
      parseRateSelect(res) {
        if (Array.isArray(res)) {
          return res
        }
        if (res && Array.isArray(res.data)) {
          return res.data
        }
        return []
      },
      getDefaultStationStatus() {
        const statusList = this.enumData.stationStatusData || []
        const normal = statusList.find((item) => item.message === '正常使用')
        return normal ? normal.value : '50'
      },
      stationAdd() {
        this.addFormVisible = false
        const operatorId = sessionStorage.getItem('operatorId')
        if (!operatorId) {
          this.showNoRateAlert()
          return
        }
        stationApi.getRateSelectByOperatorId([operatorId]).then((res) => {
          const rates = this.parseRateSelect(res)
          if (!rates.length) {
            this.showNoRateAlert()
            return
          }
          this.serviceBillingRulesSelect = rates
          this.$nextTick(() => {
            this.addFormVisible = true
            this.editForm = Object.assign({
              isCoupons: 'N',
              stationStatus: this.getDefaultStationStatus(),
              isCec:'N',
              isInvoice:'Y',
              isParkingFee:'Y',
              fastOrSlow:'S',
              businessType:'OWN',
              serviceBillingRulesIdTemp: '',
              parkingNotice: '以场地实际收费为准'
            })
          })
        }).catch(() => {
          this.showNoRateAlert()
        })
      },
      showViewVisible(index, row) {
        this.stationDetail(index, row)
        this.searchTabsAdd(index, row)
        this.bindingRate(index, row)
        this.uploadAvatar(index, row)
        //this.uploadSitePic(index, row)
        this.createPileAndGun(index,row)
        this.newUploadSitePictures(index,row)
        this.viewVisible = true
      },
      /*newUploadSitePictures(index,row){
        console.log("open view about station upload images");
      },*/
      stationEdit(index, row) {
        this.editFormVisible = true

        this.editForm = Object.assign({}, row)
        this.editForm.canUse = this.editForm.canUseCode
        this.editForm.stationType = this.editForm.stationTypeCode
        this.editForm.stationStatus = this.editForm.stationStatusCode
        this.editForm.feesTakeUpPile = this.editForm.feesTakeUpPileCode
        this.editForm.addressType = this.editForm.addressTypeCode
        this.editForm.isCec = this.editForm.isCecCode
        this.editForm.fastOrSlow = this.editForm.fastOrSlowCode
        this.editForm.businessType = this.editForm.businessTypeCode
        this.editForm.commissionChargeFlag = this.editForm.commissionChargeFlagCode
        this.editForm.isParkingFee = this.editForm.isParkingFeeCode
        this.editForm.addressType = this.editForm.addressTypeCode
        this.editForm.supportOrder = this.editForm.supportOrderCode
        this.editForm.isInvoice = this.editForm.isInvoiceCode
        this.editForm.isNaming = this.editForm.isNamingCode
        this.editForm.parkLock = this.editForm.parkLockCode
        this.editForm.isCoupons = this.editForm.isCoupons.code;
      },
      stationDetail(index, row) {
        this.detailForm = Object.assign({}, row)
      },
      editSubmit(editForm) {
        editForm.validate((valid) => {
          if (!valid) {
            return;
          } else {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.editSubmitLoading = true
              const isNewStation = !this.editForm.id
              const rateId = this.editForm.serviceBillingRulesIdTemp
              let paramObj = Object.assign({}, this.editForm)
              if (isNewStation && rateId) {
                paramObj.serviceBillingRulesId = rateId
              }
              let param = JSON.stringify(paramObj)
              stationApi.saveOrUpdateStation(param).then((res) => {
                  this.editSubmitLoading = false
                  if (res.code === 0) {
                    const finishSave = () => {
                      this.$message({
                        message: res.message,
                        type: 'success'
                      })
                      this.submitStationSearchForm()
                      this.editFormVisible = false
                      this.addFormVisible = false
                    }
                    if (isNewStation && rateId) {
                      const stationId = res.data && (res.data.id != null ? res.data.id : res.data)
                      if (stationId) {
                        stationApi.bindingRate({
                          id: stationId,
                          operatorId: this.editForm.operatorId,
                          serviceBillingRulesId: rateId
                        }).then((bindRes) => {
                          if (!bindRes) {
                            this.$message.warning('充电站已保存，但费率绑定失败，请在详情中手动绑定')
                          }
                          finishSave()
                        }).catch(() => {
                          this.$message.warning('充电站已保存，但费率绑定失败，请在详情中手动绑定')
                          finishSave()
                        })
                        return
                      }
                    }
                    finishSave()
                  } else {
                    this.$message.error(res.message)
                    this.editFormVisible = false
                    this.addFormVisible = false
                  }
                }
              )
            })
          }
        })
      },
      // closeDialog(add){
      //   if (add === "add"){
      //     this.editFormVisible = false
      //   }
      // },
      // 删除
      stationDelete(index, row) {
        this.$confirm('确定要删除：' + row.stationName + '吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          stationApi.deleteStation(row.id).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.submitStationSearchForm();
            } else {
              this.$message.error(res.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
      },
      closeEditForm() {
        this.editFormVisible = false
      },
      closeAddForm() {
        this.addFormVisible = false;
      },
      closeSafetyEditForm() {
        this.safetyEditForm = Object.assign({})
        this.newUploadSitePicturesList = []
        this.safetyEditFormVisible = false
      },
      closeNewEditForm() {
        this.newEditFormVisible = false
      },
      showInnerForm() {
        this.centerTemp.lng = this.editForm.longitude == null ? 121.384555 : this.editForm.longitude
        this.centerTemp.lat = this.editForm.latitude == null ? 31.069087 : this.editForm.latitude
        this.provinceTemp = this.editForm.province
        this.cityTemp = this.editForm.city
        this.districtTemp = this.editForm.area
        this.addressTemp = this.editForm.address
        this.dialogInnerVisible = true
      },
      // 点击获取到当前经纬度
      getClickInfo(e) {
        const myGeo = new window.BMap.Geocoder()
        myGeo.getLocation(e.point, data => {
          if (data) {
            this.centerTemp = {lng: e.point.lng, lat: e.point.lat}
            this.provinceTemp = data.addressComponents.province
            this.cityTemp = data.addressComponents.city
            this.districtTemp = data.addressComponents.district
            this.addressTemp = data.address
          }
        })
      },
      confirmAddress() {
        this.editForm.longitude = this.centerTemp.lng
        this.editForm.latitude = this.centerTemp.lat
        this.editForm.province = this.provinceTemp
        this.editForm.city = this.cityTemp
        this.editForm.area = this.districtTemp
        this.editForm.address = this.addressTemp;
        if (this.editForm.address) this.$refs.editForm.clearValidate("address")
        this.dialogInnerVisible = false
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      changePage() {
        this.submitStationSearchForm()
      },
      // 显示绑定费率页面
      bindingRate(index, row) {
        this.bindingRateForm = {
          id: row.id,
          serviceBillingRulesId: row.serviceBillingRulesId,
          ruleName: '',
          operatorId: row.operatorId
        }
        if (this.bindingRateForm.serviceBillingRulesId) { // 若果已经绑定了费率，则查询费率名称，显示解绑页面
          stationApi.getRateNameById(this.bindingRateForm.serviceBillingRulesId).then((res) => {
            this.bindingRateForm.ruleName = res.ruleName
          })
        } else { // 如果没有绑定费率，则查询运营商关联的费率列表，显示绑定页面
          // 获取当前登陆/或选择的运营商ID
          stationApi.getRateSelectByOperatorId([this.bindingRateForm.operatorId]).then((res) => {
            this.serviceBillingRulesSelect = res
          })
        }
      },
      // 解绑费率
      unbinding() {
        this.$confirm('确定要解绑 ' + this.bindingRateForm.ruleName + ' 吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let param = Object.assign({}, this.bindingRateForm)
            param.serviceBillingRulesId = null
            stationApi.bindingRate(param).then((res) => {
              if (res) {
                this.$message({
                  message: '解绑成功',
                  type: 'success'
                })
                stationApi.getRateSelectByOperatorId([this.bindingRateForm.operatorId]).then((res) => {
                  this.serviceBillingRulesSelect = res
                })
                this.bindingRateForm.serviceBillingRulesId = null
                this.viewVisible=false
                this.submitStationSearchForm()
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作！'
            })
          })
      },
      // 绑定费率
      dobinding(bindingRateForm) {
        bindingRateForm.validate((valid) => {
          if (!valid) {
            return;
          } else {
            this.$confirm('确定要绑定吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                let param = Object.assign({}, this.bindingRateForm)
                param.serviceBillingRulesId = this.bindingRateForm.serviceBillingRulesIdTemp
                stationApi.bindingRate(param).then((res) => {
                  if (res) {
                    this.$message({
                      message: '绑定成功',
                      type: 'success'
                    })
                    stationApi.getRateNameById(this.bindingRateForm.serviceBillingRulesIdTemp).then((res) => {
                      this.bindingRateForm.ruleName = res.ruleName
                    })
                    this.bindingRateForm.serviceBillingRulesId = this.bindingRateForm.serviceBillingRulesIdTemp
                    this.viewVisible=false
                    this.submitStationSearchForm()
                  }
                })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消操作！'
                })
              })
          }
        })
      },
      // 显示标签页
      searchTabsAdd(index, row) {
        this.searchTabsAddForm.id = row.id
        stationApi.getSearchTabs(row.id).then((res) => {
          if (res.code === 0) {
            this.searchTabsAddForm.listTag = res.data
          }
        })
      },
      //重置头像
      revertUploadAvatarFormFileList(){
        this.uploadAvatarFormFileList=[]
      },
      //重置图片
      revertUploadSitePicFormFileList(){
        this.uploadSitePicFormFileList=[]
      },
      revertStationPicturesFormFileList(){
        this.newUploadSitePicturesList=[]
      },
      // 自动填充input
      queryRateGroupId(queryString, cb) {
        var restaurants = this.restaurants
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
        // 调用 callback 返回建议列表的数据
        cb(results)
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      loadAll() {
        let param = {operatorId: this.editForm.operatorId}
        stationApi.queryRateGroupId(param).then((res) => {
          if (res.code === 0) {
          } else {
          }
        })
        return []
      },
      handleSelect(item) {
      },
      // 加载下拉框
      loadSelectItem() {

        //加载充电站下拉框
        stationApi.getStationEnum().then((res) => {
          this.enumData.canUseData = JSON.parse(res.canUseData)
          this.enumData.stationStatusData = JSON.parse(res.stationStatusData)
          this.enumData.stationTypeData = JSON.parse(res.stationTypeData)
          this.enumData.feesTakeUpPileData = JSON.parse(res.feesTakeUpPileData)
          this.enumData.isCecData = JSON.parse(res.isCecData)
          this.enumData.isProfitData = JSON.parse(res.isCecData)
          this.enumData.isCouponsData = JSON.parse(res.isCecData);
          this.enumData.fastOrSlowData = JSON.parse(res.fastOrSlowData)
          this.enumData.YesNoEnumData = JSON.parse(res.YesNoEnumData)
          this.enumData.addressTypeData = JSON.parse(res.addressTypeData)
          this.enumData.businessTypeData = JSON.parse(res.businessTypeData)
          this.enumData.protocolEnumData = JSON.parse(res.protocolEnumData)
        //  this.enumData.pileModelEnumData = JSON.parse(res.pileModelEnumData)
        })
        // 站下拉框
        commonApi.stationsForSelectByOperatorId(this.$store.getters.operatorIds).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data
          }
        })
        // 运营商下拉框
        commonApi.getOperatorsTree().then((res) => {
          if (res.code === 0) {
            this.operatorForSelect = res.data
          }
        })

        // 审核状态下拉框
        safetyApi.getSafetyEnum().then((res) => {
          this.enumData.auditStatusEnum = JSON.parse(res.auditStatusEnum)
        })

      },
      operatorSelect(val) {
        commonApi.stationsForSelectByOperatorId([val]).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data
          }
        })
      },
      uploadFile(file){
        return new Promise(function(resolve, reject) {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = function() {
            resolve(this.result)
          }
        })
      },

      uploadAvatar(index, row){
        let domain = sysConfig.apiPre;
        if(domain==="http://localhost"){
          domain='http://qectest.qingec.com/';
        }
        stationApi.getLogo(row.id).then((res) => {
          if (res.code === 0) {
            if (res.data==null || res.data===''){
              this.uploadAvatarFormFileList=[]
            }else {
              this.uploadAvatarFormFileList= [{name: "", url: domain + '/' + res.data}]
            }
            this.uploadAvatarForm={
              id:row.id,
              stationCode:row.stationCode,
              logo:this.uploadAvatarFormFileList
            }
          } else {
            this.uploadAvatarFormFileList=[]
          }
        })
      },

      newUploadSitePictures(index, row){
        let domain = sysConfig.apiPre;
        if(domain==="http://localhost"){
          domain='http://qectest.qingec.com/';
        }
        stationApi.getPicture(row.id).then((res) => {
          if (res.code === 0) {
            this.uploadSitePicFormFileList=[]
            let picJson = []
            if (res.data==null||res.data==""){

            }else {
              picJson = res.data
            }
            for (let index in picJson){
              this.uploadSitePicFormFileList.push({name:"",url:picJson[index]});
              this.newUploadSitePicturesList.push(
                {
                  name:picJson[index],
                  url:picJson[index]
                }
              );
              this.stationImageUrlList.push(picJson[index]);
            }
            this.uploadSitePicForm={
              id:row.id,
              stationCode:row.stationCode,
              picture:this.uploadSitePicFormFileList
            }
            this.newUploadSitePicturesForm={
              id:row.id,
              picture:this.newUploadSitePicturesList
            }
          } else {
            this.uploadSitePicFormFileList=[];
            this.newUploadSitePicturesList=[];
          }
        })
      },
    },
    components: {
      Pagination,
      search,
      safetySearch,
      list,
      safetyList,
      add,
      addSafety,
      quickAdd,
      customizeView,
      update
    },
    created: function () {
      this.loadSelectItem()
    },
    mounted: function () {
      this.submitStationSearchForm();
      // this.restaurants = this.loadAll()
    },
    watch: {
      'editForm.feesTakeUpPile'() {
        if (this.editForm.feesTakeUpPile == 'N') {
          this.editForm.takeUpTime = 0
          this.editForm.takeUpPrice = 0
          this.editForm.takeUpAmountTop = 0
        }
      },
      'editForm.isParkingFee'() {
        if (this.editForm.isParkingFee == 'N') {
          this.editForm.parkingLotFee = 0
        }
      },
      '$store.state.operatorId': {
        handler: function (newVal, oldVal) {
          this.submitStationSearchForm()
        },
        deep: true
      }
    },
    filters: {
      statusFilter(stationStatus) {
        const statusMap = {
          0: 'warning',
          1: 'primary',
          5: 'info',
          6: 'danger',
          50: 'success'
        }
        return statusMap[stationStatus]
      }
    }
  }
</script>

<style scoped lang="less">
  .el_search {
    background-color: teal;
    color: white;
  }

  .el_clear {
    background-color: darkorange;
    color: white;
  }
  .BaiduMap {
    height: 300px;

    div {
      height: 300px;
    }
  }
  .el-btn {
    /*float: right;*/
    margin-bottom: 15px;
  }

  /deep/ .search_form {
    .el-form-item__content {
      .el-input {
        width: auto;
      }
    }
  }

  /deep/ .el-dialog__body {
    padding: 10px 10px;
  }

  /deep/ .el-tabs__header {
    margin: 0 0 5px;
  }

  /deep/ .row_input {
    .el-form-item__content {
      .el-input {
        width: 100%;
      }
    }
  }

  /deep/ .row_input {
    .el-col {
      .el-form-item {
        margin-bottom: 10px;
      }
    }
  }

  /deep/ .rows_input {
    .el-col {
      .el-form-item {
        margin-bottom: auto;
      }
    }
  }

  .el_row_input {
    .el_col_input {
      width: auto;
    }
  }
  /deep/.el-dialog{
    width: 900px;
  }
  /deep/ .edit_form {
    height: 600px;
    overflow: auto;

    .el-form-item__label {
      color: rgba(0, 0, 0, 0.47);
    }
  }
  /deep/ .diy-class {
    .el-form-item__content {
      line-height: 0px;
    }
  }
  #live2dcanvas {
    border: 0 !important;
  }
</style>

<style lang="scss">
.station-no-rate-alert {
  width: 420px;

  .el-message-box__message {
    padding-top: 6px;
  }

  .el-message-box__content {
    padding-bottom: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager.vue